import withSharedStyles from "../../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, fontSize } = theme.tokens;

  return {
    card: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 4,
      minWidth: 0,
      height: "100%"
    },
    tile: {
      position: "relative",
      aspectRatio: "1 / 1",
      borderRadius: radius.tile,
      backgroundColor: color.surface,
      marginBottom: 8,
      overflow: "hidden",
      transition: "background-color .2s ease",
      // aspect-ratio fallback for older Safari
      "@supports not (aspect-ratio: 1 / 1)": {
        height: 0,
        paddingBottom: "100%"
      }
    },
    imageLink: {
      position: "absolute",
      inset: 0,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "12%",
      boxSizing: "border-box",
      "& img": {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        mixBlendMode: "multiply",
        transition: "transform .25s ease"
      }
    },
    isOut: {
      "& $imageLink img": { opacity: 0.45 }
    },
    topLeft: {
      position: "absolute",
      top: 10,
      left: 10,
      right: 10,
      display: "flex",
      flexWrap: "wrap",
      gap: 4,
      pointerEvents: "none"
    },
    discount: {
      backgroundColor: color.deal,
      color: color.bg,
      fontSize: fontSize.micro,
      fontWeight: 700,
      padding: "4px 8px",
      borderRadius: radius.badge,
      lineHeight: 1.3
    },
    outLabel: {
      position: "absolute",
      left: 10,
      bottom: 10,
      backgroundColor: color.bg,
      color: color.text2,
      fontSize: fontSize.micro,
      fontWeight: 700,
      padding: "4px 8px",
      borderRadius: radius.badge
    },
    action: {
      position: "absolute",
      right: 10,
      bottom: 10,
      zIndex: 1
    },
    priceRow: {
      display: "flex",
      alignItems: "baseline",
      flexWrap: "wrap",
      columnGap: 6
    },
    price: {
      fontSize: fontSize.title,
      fontWeight: 800,
      color: color.ink
    },
    was: {
      fontSize: fontSize.small,
      color: color.muted,
      textDecoration: "line-through"
    },
    name: {
      fontSize: fontSize.body,
      lineHeight: 1.35,
      color: color.text2,
      textDecoration: "none",
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      transition: "color .15s ease"
    },
    pack: {
      fontSize: fontSize.small,
      color: color.muted
    },
    footer: {
      marginTop: "auto",
      paddingTop: 8
    },
    srOnly: {
      position: "absolute",
      width: 1,
      height: 1,
      overflow: "hidden",
      clip: "rect(0 0 0 0)",
      whiteSpace: "nowrap"
    },
    // hover effects go last: JSS resolves $refs only to classes defined above
    // Hovering anywhere on the card lifts the tile and highlights the name
    // (the add button keeps its own hover).
    [theme.media.hover]: {
      card: {
        "&:hover $tile": { backgroundColor: color.surfaceHover },
        "&:hover $imageLink img": { transform: "scale(1.04)" },
        "&:hover $name": { color: color.brandText }
      }
    }
  };
});

export default withCustomStyles;
